import { useCCStartNodes } from "components/CC/context/CCStartNodesContext.tsx";
import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { StartForm } from "../Forms/StartForm.tsx";

export const StartDrawer = () => {
    const { existingFlowTypes, totalStarts } = useCCStartNodes();
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Start} title={t("nodes.start.drawers.title")}>
            <StartForm formId={FormId.StartForm} existingFlowTypes={existingFlowTypes} totalStarts={totalStarts} />
        </BaseConnectionCreatorDrawer>
    );
};
